import React, { Component } from 'react';
import {I18n} from '../../../I18n/components/person';
import {Button, Card, CardTitle} from 'reactstrap';
import PaginationList from '../../PaginationList/PaginationList';
import {API_BASE_URL} from '../../../helpers/constants';
import noImg from '../../../assets/images/img-error.svg';
import CardSubtitle from 'reactstrap/es/CardSubtitle';
import './packageAppList.css';

class PackageAppList extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    generateList = items => {
        return items.map((item, index) => {
            return (
                <Card
                    className="packageAppItem"
                    key={item.mobileAppId || index}
                >
                    <div className="packageAppItem__imageWrapper">
                        <img
                            src={`${API_BASE_URL}/apps/mobileapps/download/icon?packageName=${item.mobileApp.packageName}`}
                            alt="application logotype"
                            className="img-fluid media-object"
                            width="60"
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = noImg
                            }}
                        />
                    </div>
                    <CardTitle>{item.mobileApp.appLabel}</CardTitle>
                    <Button
                        className="packageAppItem__btn"
                        color="primary"
                        size="sm"
                        type="button"
                        block
                        onClick={() => {
                            window.open(`https://play.google.com/store/apps/details?id=${item.mobileApp.packageName}`,
                            "_blank")
                        }}>
                        {I18n[this.props.lang].install}
                    </Button>

                </Card>
            )
        });
    };

    render() {
        return (
            <div className="packageAppList">
                <div className="packageAppList__content">
                    {this.generateList(this.props.data)}
                </div>
                <PaginationList
                    totalPages={this.props.totalPages}
                    currentPage={this.props.currentPage}
                    paginatedList={this.props.paginatedList}
                    setCurrentPage={this.props.setCurrentPage}
                    setPaginatedList={this.props.setPaginatedList}
                />
            </div>
        )
    }
}

export default PackageAppList;



// WEBPACK FOOTER //
// ./src/components/Person/PackageAppList/PackageAppList.js